import { DiagnosisItem, TmjOptions } from "../../diagnosis.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { ItemValidators } from "../../../item-validators";
import { AbstractCondition } from "../condition";

export class Tmj extends AbstractCondition {
  static validate(
    item: DiagnosisItem,
    odontogram: Tooth[],
    items: DiagnosisItem[],
  ): boolean {
    // validate options
    if (!ItemValidators.hasOptionObjectSelected(item)) {
      return false;
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: DiagnosisItem): Tooth[] {
    return odontogram;
  }

  static getDescriptionIdentifiers(item): string[] {
    const identifiers = [];

    if (item.options.bruxism) {
      identifiers.push("tmj_bruxism");
    }
    if (item.options.tmj_disorder) {
      identifiers.push("tmj_tmj_disorder");
    }
    if (item.options.muscle_disorder) {
      identifiers.push("tmj_muscle_disorder");
    }

    return identifiers;
  }

  static getDiagnosis360Changes(item): any {
    const changes = {};

    if (
      item.options.bruxism ||
      item.options.tmj_disorder ||
      item.options.muscle_disorder
    ) {
      changes["bite_joint"] = true;
    }

    return changes;
  }

  static isActive(options: TmjOptions) {
    return options.bruxism || options.tmj_disorder || options.muscle_disorder;
  }

  static supports(condition: string): boolean {
    return condition === "tmj";
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/ortho/tmj.ts